// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { AddVersion, UpdateVersion } from "../../actions/softwareActions";
import { LoadingProgress } from "imagus-components";
import AddVersionForm from "../../components/softwares/AddVersionForm";
import { DatabaseDateToJsDateISOString } from "../../../global/functions/DateTimeAmend";
import { TextareaMultilLines } from "../../../global/functions/MultilLineStrings";

type AddVersionFormReduxPropsType = {
  softwareId: string,
  version?: { [key: string]: * },
  onClose: Function,
  actions: {
    AddVersion: Function,
    UpdateVersion: Function
  }
};

class AddVersionFormRedux extends Component<AddVersionFormReduxPropsType, *> {
  AddVersion = (
    versionId: string,
    link: string,
    releaseDate: Date,
    releaseNotes: string,
    isPublic: boolean,
    isCurrent: boolean,
    isBeta: boolean,
    doneCall: Function,
    failCall: Function
  ): * => {
    this.props.actions.AddVersion(
      this.props.softwareId,
      versionId,
      link,
      releaseDate,
      releaseNotes,
      isPublic,
      isCurrent,
      isBeta,
      doneCall,
      failCall
    );
  };

  UpdateVersion = (
    newVersionId: string,
    link: string,
    releaseDate: Date,
    releaseNotes: string,
    isPublic: boolean,
    isCurrent: boolean,
    isBeta: boolean,
    doneCall: Function,
    failCall: Function
  ): * => {
    this.props.actions.UpdateVersion(
      this.props.softwareId,
      this.props.version.versionId,
      newVersionId,
      link,
      releaseDate,
      releaseNotes,
      isPublic,
      isCurrent,
      isBeta,
      doneCall,
      failCall
    );
  };
  render(): React$Element<*> {
    let initialForm = {};
    let isEdit;
    const version = this.props.version;

    if (version) {
      initialForm.versionid = version.versionId;
      initialForm.link = version.link;
      initialForm.releaseDate = DatabaseDateToJsDateISOString(
        version.releaseDateOrigin
      );
      initialForm.notes = TextareaMultilLines(version.releaseNotes);
      initialForm.isCurrent = version.isCurrent;
      initialForm.isPublic = version.isPublic;
      initialForm.isBeta = version.isBeta;

      isEdit = true;
    } else {
      isEdit = false;
    }

    return (
      <AddVersionForm
        onClose={this.props.onClose}
        initialForm={initialForm}
        isEdit={isEdit}
        AddVersion={this.AddVersion}
        UpdateVersion={this.UpdateVersion}
      />
    );
  }
}

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ AddVersion, UpdateVersion }, dispatch)
});

export default connect(
  null,
  mapDispatchToProps
)(AddVersionFormRedux);
